import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes, ETitleTextColCtaStyles } from "../../../config/enums.js";
import TitleTextCol from "./TitleTextCol.svelte";

export default {
    component: TitleTextCol,
    name: "Title Text Column",
    description: "Column layout for displaying a title and text list",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-titletextcol--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/columns-2.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F23ec7de5e2d64820aa56aecc44d8d691",
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Text List",
            name: "textList",
            type: "list",
            subFields: [
                {
                    friendlyName: "Text",
                    name: "text",
                    type: "longText",
                },
                {
                    friendlyName: "Link",
                    name: "link",
                    type: "object",
                    subFields: [
                        {
                            friendlyName: "To",
                            name: "to",
                            type: "text",
                        },
                        {
                            friendlyName: "Text",
                            name: "text",
                            type: "text",
                        },
                        {
                            friendlyName: "CTA Style",
                            name: "ctaStyle",
                            type: "text",
                            enum: Object.values(ETitleTextColCtaStyles),
                            defaultValue: ETitleTextColCtaStyles.TEXT_LINK,
                        },
                    ],
                },
            ],
        },
    ],
};
